import { Box, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export const ObjectsSearchBar = ({ value, onChange }) => {
  return (
    <Box sx={{ mb: 2, mt: 1 }}>
      <TextField
        fullWidth
        size="small"
        placeholder="Search objects..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};
